import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { selectCurrency } from "../../../features/user/userSlice";
import { formatNumber } from "../../../utils/tools";
import { Button, ButtonsContainerRetiro, ErrorSpan, Form, InputContainer } from "../DepositElements";
import paraguaypasarela from '../../../assets/images/paraguaypasarela.png';
import Rbetterbro from '../../../assets/images/RETIRACONBETTERBRO.svg';


const FormTransPYG = ({
  form,
  handleChange,
  handleClose,
  solicitarRetiro,
  loading,
}) => {
  const [t] = useTranslation("global");
  const moneda = useSelector(selectCurrency);
  const [monto, setMonto] = useState(0);
  const [blur, setBlur] = useState(false);

  const handleMonto = (e) => {
    setBlur(true);
    handleChange(formatNumber(e));
    setMonto(parseFloat(e.target.value.replaceAll(".", "").replace(",", ".")));
    if (e.target.value === "") setMonto(0);
  };

  return (
    <Form>
      <InputContainer>
        <label>NOMBRE DEL BANCO:</label>
        <select value={form.bank_code} onChange={handleChange} name='bank_code'>
          <option disabled value=''>{t("deposit.lbl-bank")}</option>
          <option value='0001'>BANCO CENTRAL DEL PARAGUAY</option>
          <option value='0010'>BANCO NACIONAL DE FOMENTO</option>
          <option value='0030'>BANCO DE LA NACION ARGENTINA</option>
          <option value='0040'>BANCO GNB PARAGUAY S.A.</option>
          <option value='0050'>BANCO DO BRASIL S.A.</option>
          <option value='0070'>CITIBANK N.A.</option>
          <option value='0080'>SUDAMERIS BANK S.A.E.C.A.</option>
          <option value='0110'>BANCO ITAU PARAGUAY S.A.</option>
          <option value='0120'>BANCO CONTINENTAL S.A.</option>
          <option value='0130'>BANCO BASA (ex - Amambay)</option>
          <option value='0140'>VISION BANCO S.A.E.C.A.</option>
          <option value='0150'>BANCO RIO S.A.E.C.A. (Ex - Itapua)</option>
          <option value='0170'>BANCO FAMILIAR S.A.E.C.A.</option>
          <option value='0190'>BANCO ATLAS</option>
          <option value='0200'>BANCOP S.A.</option>
          <option value='0210'>INTERFISA BANCO</option>
          <option value='0220'>FINANCIERA UENO S.A.E.C.A.</option>
          <option value='0230'>CRISOL Y ENCARNACION FINANCIERA S.A.</option>
          <option value='0240'>FINLATINA S.A. DE FINANZAS</option>
          <option value='0250'>FINANCIERA PARAGUAYO-JAPONESA S.A.E.C.A.</option>
          <option value='0260'>FINANCIERA EXPORTADORA PARAGUAYA S.A.</option>
          <option value='0270'>SOLAR S.A. DE AHORRO Y PRESTAMO PARA LA VIVIENDA</option>
          <option value='0280'>TU FINANCIERA S.A.</option>
          <option value='0290'>FIC S.A. DE FINANZAS</option>
        </select>
      </InputContainer>

      <InputContainer>
        <label>{t('deposit.account-number')}:</label>
        <input
          type='text'
          placeholder={t('deposit.account-number')}
          name='account_number'
          value={form.account_number}
          onChange={handleChange}
        />
      </InputContainer>
      <InputContainer>
        <label>{t("deposit.documentType")}:</label>
        <select value={form.document_type} onChange={handleChange} name='document_type' >
          <option disabled value=''>{t("deposit.select-document-type")}</option>
            <option value='CI'>CÉDULA DE IDENTIDAD</option>
        </select>
      </InputContainer>
      <InputContainer>
        <label>{t("deposit.id")}</label>
        <input
          type="text"
          placeholder={t("deposit.id")}
          name="document_number"
          value={form.document_number}
          onChange={handleChange}
        />
      </InputContainer>
      <InputContainer>
        <label>{t("deposit.lbl-amount")}</label>
        <input
          type="text"
          placeholder="0,00"
          name="monto"
          value={form.monto}
          onChange={(e) => handleMonto(e)}
        />

        {moneda === 'PYG' && monto < 10000 && blur && (
          <ErrorSpan>
            {t("deposit.amount-greater-than")} 10.000 {moneda}{" "}
          </ErrorSpan>
        )}
        {moneda === 'PYG' && monto > 10000000 && blur && (
          <ErrorSpan>
            {t("deposit.amount-less-than")} 10.000.000 {moneda}{" "}
          </ErrorSpan>
        )}

      </InputContainer>
      <img src={Rbetterbro} alt='Rbetterbro' className={'pyg0'} style={{width:'40%', marginLeft: '30%', marginTop: '5%'}}/>
      {moneda === 'PYG' && (
        <img src={paraguaypasarela} alt='Pasarelas paraguay' className={'pyg2'} style={{width:'100%', marginTop: '0.5%', marginLeft: '-1%'}}/>
      )}
      <ButtonsContainerRetiro style={{marginTop:'-160px'}}>
        <Button
          onClick={(e) => {
            e.preventDefault();
            handleClose();
          }}
        >
          {t("deposit.btn-cancel")}
        </Button>
        <Button
          primary={true}
          disabled={loading || (monto < 10000 && moneda === 'PYG') || (monto > 10000000 && moneda === 'PYG')}
          onClick={solicitarRetiro}
        >
          {loading ? t("deposit.loading") : t("deposit.btn-confirm")}
        </Button>
      </ButtonsContainerRetiro>
    </Form>
  );
};

export default FormTransPYG;